import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

/**
 * The active-underline geometry is driven by runtime values (tab count / active
 * index), so those continuous values are passed as CSS custom properties from the
 * consumer (see tab-bar.component.tsx): --tab-width, --tab-underline-x, --tab-underline-opacity.
 */
export const tabBarStyle = css`
  width: 100%;

  /* Prevents inadvertent collapsing inside a flex parent */
  min-height: 40px;
  height: 40px;
  display: flex;
  position: relative;

  &:focus {
    outline: none;
  }

  &::after {
    content: '';
    display: block;
    height: 2px;
    background: ${theme.colors.primary50};
    position: absolute;
    bottom: -1px;
    left: 0;
    transition: transform 0.3s ease-out;
    width: var(--tab-width);
    opacity: var(--tab-underline-opacity);
    transform: translateX(var(--tab-underline-x));
  }

  a,
  button {
    min-width: var(--tab-width);
    flex-basis: var(--tab-width);
  }
`;

export const tabItemStyle = css`
  font-family: ${theme.font.family};
  font-size: ${theme.font.size.medium};
  color: ${theme.font.colors.light};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  text-decoration: none;
  transition: background 0.25s ease-out;

  &:hover,
  &:focus {
    background: ${theme.colors.neutral5};
    color: ${theme.colors.neutral80};
    outline: none;
  }

  &.selected,
  &[aria-selected='true'] {
    color: ${theme.colors.primary50};
    font-weight: ${theme.font.weight.bold};

    &:focus::after {
      background: ${theme.colors.neutral80};
    }
  }
`;
